import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Body = styled.div`
  display: flex;
  gap: 30px;
  padding: 40px 50px;
  flex-direction: column;
  text-align: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 20px;
    padding: 20px 25px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 10px;
  }
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '0',
}))`
  font-weight: 500;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const Description = styled(Typography.Body).attrs(() => ({
  $variant: '0',
}))`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 15px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;
